module.exports = __webpack_public_path__ + "img/swiper_01.4b32534b.jpg";